import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import TagManager from 'react-gtm-module';

import { Button, Section, Highlight, SectionWrapper } from '@/components/GlobalMenu/Desktop/MenuItem.style';

import Dropdown from './Dropdown';
import Placeholder from '../../Placeholder';

class MenuItem extends React.Component {
  state = {
    onButton: false,
  };

  enterButton = () => this.setState({ onButton: true });

  leaveButton = () => this.setState({ onButton: false });

  handleClick = () => this.setState(({ onButton }) => ({ onButton: !onButton }));

  render() {
    const { onButton } = this.state;
    const { menuItem, locale, top, white } = this.props;

    let section = (
      <Section onMouseEnter={this.enterButton} onClick={this.handleClick} white={top && white}>
        {menuItem.label || <Placeholder h="15px" w="65px" />}
        <Highlight show={onButton || window.location.href.includes(menuItem.url)} />
      </Section>
    );

    if (menuItem.url && menuItem.external) {
      section = (
        <a
          href={menuItem.url}
          target="_blank"
          onClick={() => {
            TagManager.dataLayer({
              dataLayer: {
                event: 'clickheader',
                clickurl: `/${locale}${menuItem.url}`,
              },
            });
          }}
        >
          {section}
        </a>
      );
    } else if (menuItem.url) {
      section = (
        <Link
          to={`/${locale}${menuItem.url}`}
          href={`/${locale}${menuItem.url}`}
          style={{ textDecoration: 'none' }}
          onClick={() => {
            TagManager.dataLayer({
              dataLayer: {
                event: 'clickheader',
                clickurl: `/${locale}${menuItem.url}`,
              },
            });
          }}
        >
          {section}
        </Link>
      );
    }

    section = <SectionWrapper>{section}</SectionWrapper>;
    return (
      <Button onMouseLeave={this.leaveButton}>
        {section}
        {menuItem.children && <Dropdown top={top} open={onButton} locale={locale} menuItem={menuItem} />}
      </Button>
    );
  }
}

MenuItem.propTypes = {
  menuItem: PropTypes.shape().isRequired,
  locale: PropTypes.string.isRequired,
  top: PropTypes.bool.isRequired,
  white: PropTypes.bool.isRequired,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/MenuItem.js